// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IClaimActorDto } from './IClaimActorDto';
import {
    IClaimActorDtoFromJSON,
    IClaimActorDtoFromJSONTyped,
    IClaimActorDtoToJSON,
    IClaimActorDtoToJSONTyped,
} from './IClaimActorDto';
import type { IClaimEscalationNoteResponseDto } from './IClaimEscalationNoteResponseDto';
import {
    IClaimEscalationNoteResponseDtoFromJSON,
    IClaimEscalationNoteResponseDtoFromJSONTyped,
    IClaimEscalationNoteResponseDtoToJSON,
    IClaimEscalationNoteResponseDtoToJSONTyped,
} from './IClaimEscalationNoteResponseDto';

/**
 * 
 * @export
 * @interface IManualClaimUpdateDto
 */
export interface IManualClaimUpdateDto {
    /**
     * 
     * @type {Date}
     * @memberof IManualClaimUpdateDto
     * @deprecated
     */
    service_on?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IManualClaimUpdateDto
     */
    local_date_service_on?: Date;
    /**
     * 
     * @type {IClaimActorDto}
     * @memberof IManualClaimUpdateDto
     */
    service_for?: IClaimActorDto;
    /**
     * 
     * @type {number}
     * @memberof IManualClaimUpdateDto
     */
    provider_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IManualClaimUpdateDto
     */
    service_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IManualClaimUpdateDto
     */
    category_type?: IManualClaimUpdateDtoCategoryTypeEnum;
    /**
     * 
     * @type {IClaimEscalationNoteResponseDto}
     * @memberof IManualClaimUpdateDto
     */
    claim_escalation_note_response_dto?: IClaimEscalationNoteResponseDto;
}

/**
* @export
* @enum {string}
*/
export enum IManualClaimUpdateDtoCategoryTypeEnum {
    ADOPTION = 'ADOPTION',
    DENTAL = 'DENTAL',
    DEPENDENT_CARE = 'DEPENDENT_CARE',
    MEDICAL = 'MEDICAL',
    PARKING = 'PARKING',
    PREMIUM = 'PREMIUM',
    PHARMACY = 'PHARMACY',
    TRANSIT = 'TRANSIT',
    VISION = 'VISION',
    LIFE_STYLE = 'LIFE_STYLE',
    WELLNESS = 'WELLNESS',
    TRAVEL = 'TRAVEL',
    PLAN_SPECIFIC = 'PLAN_SPECIFIC'
}


/**
 * Check if a given object implements the IManualClaimUpdateDto interface.
 */
export function instanceOfIManualClaimUpdateDto(value: object): value is IManualClaimUpdateDto {
    return true;
}

export function IManualClaimUpdateDtoFromJSON(json: any): IManualClaimUpdateDto {
    return IManualClaimUpdateDtoFromJSONTyped(json, false);
}

export function IManualClaimUpdateDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IManualClaimUpdateDto {
    if (json == null) {
        return json;
    }
    return {
        
        'service_on': json['service_on'] == null ? undefined : (new Date(json['service_on'])),
        'local_date_service_on': json['local_date_service_on'] == null ? undefined : (new Date(json['local_date_service_on'])),
        'service_for': json['service_for'] == null ? undefined : IClaimActorDtoFromJSON(json['service_for']),
        'provider_id': json['provider_id'] == null ? undefined : json['provider_id'],
        'service_id': json['service_id'] == null ? undefined : json['service_id'],
        'category_type': json['category_type'] == null ? undefined : json['category_type'],
        'claim_escalation_note_response_dto': json['claim_escalation_note_response_dto'] == null ? undefined : IClaimEscalationNoteResponseDtoFromJSON(json['claim_escalation_note_response_dto']),
    };
}

export function IManualClaimUpdateDtoToJSON(json: any): IManualClaimUpdateDto {
    return IManualClaimUpdateDtoToJSONTyped(json, false);
}

export function IManualClaimUpdateDtoToJSONTyped(value?: IManualClaimUpdateDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'service_on': value['service_on'] == null ? undefined : ((value['service_on']).toISOString()),
        'local_date_service_on': value['local_date_service_on'] == null ? undefined : ((value['local_date_service_on']).toISOString().substring(0,10)),
        'service_for': IClaimActorDtoToJSON(value['service_for']),
        'provider_id': value['provider_id'],
        'service_id': value['service_id'],
        'category_type': value['category_type'],
        'claim_escalation_note_response_dto': IClaimEscalationNoteResponseDtoToJSON(value['claim_escalation_note_response_dto']),
    };
}

